<template>
    <svg
        class="w-4 h-4"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        xmlns="http://www.w3.org/2000/svg"
    >
        <!-- Checkbox outline -->
        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" fill="none"/>
        <!-- Checkmark -->
        <path d="M7 12l4 4 6-8" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
